export var WorkatoConnectionProvider;
(function (WorkatoConnectionProvider) {
    WorkatoConnectionProvider["HUBSPOT"] = "hubspot";
    WorkatoConnectionProvider["MARKETO"] = "marketo";
    WorkatoConnectionProvider["SALESFORCE"] = "salesforce";
    WorkatoConnectionProvider["PROVIDER_UNSPECIFIED"] = "provider_unspecified";
})(WorkatoConnectionProvider || (WorkatoConnectionProvider = {}));
export var CompanyType;
(function (CompanyType) {
    CompanyType["Unspecified"] = "unspecified";
    CompanyType["Media"] = "media";
    CompanyType["Subscription"] = "subscription";
})(CompanyType || (CompanyType = {}));
//# sourceMappingURL=Company.js.map